import React, { useEffect, useState } from 'react'
import * as Styles from './styles'
import Icon from '../../icon'

type Props = {
  children: JSX.Element
  onClose: Function
  style?: object
  title: string
}

const Announcement: React.FC<any> = (props: Props) => {
  const [isOpen, setIsOpen] = useState(true)
  const [closeTheme, setCloseTheme] = useState('')

  useEffect(() => {
    setCloseTheme(isOpen ? '' : 'closeTheme')
  }, [isOpen])

  const onClick = (): void => {
    setIsOpen(!isOpen)
    props.onClose()
  }

  return (
    <Styles.Announcement className={closeTheme}>
      <Styles.Header>
        {props.title && <Styles.Title>{props.title}</Styles.Title>}
        <Styles.CloseButton onClick={onClick}>
          <Icon name="close" />
        </Styles.CloseButton>
      </Styles.Header>
      <Styles.Container>{props.children}</Styles.Container>
    </Styles.Announcement>
  )
}

export default Announcement
